import React from 'react';
import { GoBack, Heading, Wrap } from './ErrorBoundary.styled';
import { Label } from './_utility';
import ArrowLeft from './assets/icons/chevron-left.svg';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo); // eslint-disable-line
  }

  render() {
    const { children, error } = this.props;
    const { hasError } = this.state;

    if (hasError || error) {
      return (
        <Wrap>
          <Heading>
            <Label name="genericErrorTitle" />
          </Heading>
          <GoBack href="/" onClick={() => window.history.back()}>
            <ArrowLeft /> <Label name="genericErrorBack" />
          </GoBack>
        </Wrap>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
